import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import { z } from "zod";

type OrderItemId_V2 = Branded<"OrderItemId_V2", string>;
type OrderItemId_V1 = Branded<"OrderItemId_V1", string>;
type OrderItemId = OrderItemId_V2;

const {
    zodSchema: orderItemIdZodSchema_V2,
    factory: orderItemIdFactory_V2,
    assert: isOrderItemId_V2,
} = genericId<OrderItemId_V2>("order_item_v2__", {
    regexMatch: /(^order_item_v2__.*$)/,
});
const {
    zodSchema: orderItemIdZodSchema_V1,
    factory: orderItemIdFactory_V1,
    assert: _isOrderItemId_V1,
} = genericId<OrderItemId_V1>("order_item__", {
    regexMatch: /(^order_item__.*$)/,
});

const isOrderItemId = isOrderItemId_V2;
const orderItemIdZodSchema = orderItemIdZodSchema_V2;
const orderItemIdFactory = orderItemIdFactory_V2;
const isOrderItemId_V1 = z.string() as unknown as z.ZodSchema<OrderItemId_V1>;
/** Still exists for legacy reasons, is used in code \
 * Won't validate with zod though and is not a valid OrderItemId \
 * TODO We'll have to check if we can remove this
 */
const emptyOrderItemId = "" as OrderItemId;

export {
    emptyOrderItemId,
    isOrderItemId,
    isOrderItemId_V1,
    isOrderItemId_V2,
    orderItemIdFactory,
    orderItemIdFactory_V1,
    orderItemIdFactory_V2,
    orderItemIdZodSchema,
    orderItemIdZodSchema_V1,
    orderItemIdZodSchema_V2,
};
export type { OrderItemId, OrderItemId_V1, OrderItemId_V2 };
